export const ProPlanData = [
    "Total 10000 conversation/month",
    "Green tick verification & assistance",
    "IP whitelisting & restriction",
    "Advanced sales chat box",
    "Custom bot flow builder",
    "Advanced Ticket & Agents analytics",
    "Dedicated support manager"
   
]